import { Star } from "lucide-react";

/**
 * Stars-only visual rating (no numeric count displayed).
 * Shows 5 star icons, filled proportionally to `value` (0-5).
 */
export default function StarRating({ value = 0, size = 16, testId = "stars" }) {
  const pct = Math.max(0, Math.min(5, Number(value) || 0)) * 20;
  return (
    <div
      className="relative inline-flex"
      aria-label={`Rated ${value} out of 5 stars`}
      data-testid={testId}
    >
      {/* Empty stars (background) */}
      <div className="flex gap-0.5 text-muted-foreground/30">
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} size={size} strokeWidth={1.5} />
        ))}
      </div>
      {/* Filled stars (foreground, clipped by width) */}
      <div
        className="absolute inset-0 overflow-hidden flex gap-0.5 text-amber-400"
        style={{ width: `${pct}%` }}
      >
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} size={size} strokeWidth={1.5} fill="currentColor" />
        ))}
      </div>
    </div>
  );
}
